import { FC } from 'react'
import { css } from '@emotion/react'
import { MyTheme, theme } from '@ui/styles/theme'
import ButtonLink from '@ui/atoms/ButtionLink'
import Title from '@ui/atoms/Title'
import { useTranslation } from 'react-i18next'
import { Languages } from '@/types/languages'
import { buildLangPath } from '@lib/pathUtils'

const Mission: FC<{
  lang: Languages
}> = ({ lang = 'ja' }) => {
  const styles = createStyles(theme)
  const { t } = useTranslation()
  const linkPath = buildLangPath('/about/', lang)

  return (
    <div css={styles.container}>
      <Title title={t('Mission')} />
      <div>
        <p css={styles.text}>{t('html.top.mission')}</p>
        <ButtonLink path={linkPath} text={t('私たちについて')} />
      </div>
    </div>
  )
}

const createStyles = (theme: MyTheme) => {
  return {
    container: css`
      width: 70vw;
      min-width: 340px;
      min-height: 340px;
      padding: 32px;
      background: ${theme.colors.white};
      ${theme.mq.isTablet} {
        width: 100%;
        min-height: initial;
      }
      ${theme.mq.isDesktop} {
        padding: 64px;
      }
    `,
    text: css`
      margin: 32px 0;
      font-size: 14px;
      line-height: 28px;
    `
  }
}

export default Mission
